module.exports = __webpack_public_path__ + "img/54.ac071db7.jpg";